module.exports = __webpack_public_path__ + "static/img/img_waist_corporate culture@2x.9dd7a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_waist_corporate culture@2x.png
// module id = GtO+
// module chunks = 0